export default __webpack_public_path__ + "static/lit-3b62dc09c133f58423807e04f66e4ea9.svg";